<template>
  <div class="customized-img">
    <div :class="`imgs-box ${classNameType}`">
      <img
        @click="$jump(item.link)"
        v-for="(item, index) in contentData"
        :key="index"
        :class="`img ${className}`"
        :src="item.address"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Img',
  components: {},
  props: {
    contentData: {
      type: Array,
      default: () => [],
    },
    setData: {
      type: Object,
      default: () => {
        return {
          showType: 'vertical', // 展示方式 vertical transverse scroll
          borderRadiusStyle: 'rightAng', // 边角样式 rightAng fillAng
          imgSpace: 'small', // 图片间距 small medium big
          pageSpace: 'none', // 页边距 none has
          topSpace: 'small', // 上边距 small medium big
          bottomSpace: 'small', // 下边距 small medium big
        }
      },
    },
  },
  data() {
    return {
      classNameType: `showType-${this.setData.showType} pageSpace-${this.setData.pageSpace} topSpace-${this.setData.topSpace} bottomSpace-${this.setData.bottomSpace}`,
      className: `borderRadiusStyle-${this.setData.borderRadiusStyle} imgSpace-${this.setData.imgSpace}`,
    }
  },
  created() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.customized-img {
  font-size: 0;
  .imgs-box {
    box-sizing: border-box;
    .img {
      width: 100%;
    }
    .img:last-child {
      margin: 0;
    }

    .borderRadiusStyle-fillAng {
      border-radius: 10px;
    }
  }
  .showType-vertical {
    .imgSpace-medium {
      margin-bottom: 10px;
    }
    .imgSpace-big {
      margin-bottom: 15px;
    }
  }
  .showType-transverse {
    width: 100%;
    display: flex;
    flex-direction: row;
    // flex-wrap: nowrap;
    .img {
      flex: 1;
      object-fit: cover;
      min-width: 10px;
      flex: 1;
    }
    .imgSpace-medium {
      margin-right: 10px;
    }
    .imgSpace-big {
      margin-right: 15px;
    }
  }
  .showType-scroll {
    width: 100%;
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    .img {
      object-fit: cover;
    }
    .imgSpace-medium {
      margin-right: 10px;
    }
    .imgSpace-big {
      margin-right: 15px;
    }
  }
  .pageSpace-has {
    padding: 0 10px;
  }
  .topSpace-medium {
    padding-top: 10px;
  }
  .topSpace-big {
    padding-top: 15px;
  }
  .bottomSpace-medium {
    padding-bottom: 10px;
  }
  .bottomSpace-big {
    padding-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/Img.vue